import * as React from 'react'
import { Eye, EyeOff } from 'lucide-react'
import { cn } from '@/lib/utils'

export type InputPasswordProps = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  'type'
>

const InputPassword = React.forwardRef<HTMLInputElement, InputPasswordProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)

    return (
      <div className='relative'>
        <input
          type={showPassword ? 'text' : 'password'}
          className={cn(
            'flex h-10 w-full rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 pr-10',
            className
          )}
          ref={ref}
          {...props}
        />
        <button
          type='button'
          className='absolute right-3 top-1/2 -translate-y-1/2 text-gray-500 hover:text-gray-700 disabled:opacity-50'
          onClick={() => setShowPassword(!showPassword)}
          disabled={props.disabled}
          tabIndex={-1}
        >
          {showPassword ? (
            <Eye className='h-4 w-4' />
          ) : (
            <EyeOff className='h-4 w-4' />
          )}
        </button>
      </div>
    )
  }
)
InputPassword.displayName = 'InputPassword'

export { InputPassword }
